<template>
  <el-dialog title="落后提醒设置" :visible.sync="modalShow">
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="120px">
      <el-form-item label="落后提醒百分比" prop="dicValue">
        <el-input type="tel" v-model.trim="form.dicValue" placeholder="落后提醒百分比" clearable />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="modalShow = false">取消</el-button>
      <el-button type="primary" size="small" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>

var dicValuevalidator = (rule, value, callback) => {
  const val = Number(value)
  if (!val) {
    return callback(new Error('请输入落后提醒百分比'));
  }
  setTimeout(() => {
    if (Number.isNaN(val)) {
      callback(new Error('请输入数字值'));
    } else {
      if (val > 100) {
        callback(new Error('落后提醒百分比不能大于100'));
      } else {
        callback();
      }
    }
  }, 100);
};

const rules = {
  dicValue: [
    { required: true, trigger: "blur", validator: dicValuevalidator, },
  ],
}
import { updateValueByKey, getValueByKeyForOrder } from "@/api/product/base"

export default {
  data () {
    return {
      modalShow: false,
      rules,
      form: {
        dicValue: null
      }
    }
  },
  methods: {
    init () {
      this.modalShow = true
      setTimeout(() => {
        this.$refs['form'].resetFields()
        this.getDetail()
      }, 300);
    },
    async getDetail () {
      const res = await getValueByKeyForOrder({
        key: "progress_backward_ratio"
      })
      if (res.code !== 0) return
      this.form.dicValue = res.data
    },
    async submit () {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        const params = {
          dicKey: "progress_backward_ratio",
          dicValue: this.form.dicValue
        }
        const res = await updateValueByKey(params)
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.modalShow = false
        this.$message.success('操作成功！')
        this.$emit('update', true)
      })
    }
  }
}
</script>

<style>
</style>